import api from "utils/api";

const isFormData = (value) => typeof FormData !== "undefined" && value instanceof FormData;

// Get all EHCs with filters
export const getAllEHCs = async (params = {}) => {
  try {
    const response = await api.get("/ehc", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get single EHC by ID
export const getEHCById = async (id) => {
  try {
    const response = await api.get(`/ehc/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get EHCs by Student ID
export const getEHCsByStudentId = async (studentId) => {
  try {
    const response = await api.get(`/ehc/student/${studentId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get EHCs by Tutor ID
export const getEHCsByTutorId = async (tutorId) => {
  try {
    const response = await api.get(`/ehc/tutor/${tutorId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Create EHC
export const createEHC = async (ehcData) => {
  try {
    const response = await api.post("/ehc", ehcData, {
      headers: isFormData(ehcData) ? { "Content-Type": "multipart/form-data" } : undefined,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Update EHC (full)
export const updateEHC = async (id, ehcData) => {
  try {
    const response = await api.put(`/ehc/${id}`, ehcData, {
      headers: isFormData(ehcData) ? { "Content-Type": "multipart/form-data" } : undefined,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Update Section A & B only
export const updateSectionAB = async (id, sectionData) => {
  try {
    const response = await api.patch(`/ehc/${id}/section-ab`, sectionData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Update EHC Status
export const updateEHCStatus = async (id, status) => {
  try {
    const response = await api.patch(`/ehc/${id}/status`, { status });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Delete EHC
export const deleteEHC = async (id) => {
  try {
    const response = await api.delete(`/ehc/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
